import { Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap, map, switchMap, catchError, filter } from "rxjs/operators";
import { SessionService } from "@cemex-core/angular-services-v8";
import { IpcFeatureToggleService } from "./../../../cemexng2components/components/feature-toggle/feature-toggle.service";

import * as fromCore from "./../reducers/index";
import * as fromLegalEntityAction from "./../actions/legalEntity.action";
import * as fromCompanyAction from "../actions/company.action";
import * as fromCountryParametersAction from "../actions/country-parameters.action";
import * as FinancialDocumentsAction from "./../../financial-documents/actions/index";

@Injectable()
export class LegalEntityEffect {
  constructor(
    private actions$: Actions,
    private session$: SessionService,
    private store$: Store<fromCore.State>,
    private featureToggleService: IpcFeatureToggleService
  ) {
    //
  }

  loadLegalEntity$ = createEffect(() =>
    this.actions$?.pipe(
      ofType<fromLegalEntityAction.LoadLegalEntity>(fromLegalEntityAction.ActionTypes.LOAD_LEGAL_ENTITY),
      switchMap((action) => {
        return this.session$.currentLegalEntity.pipe(filter((legalEntity) => legalEntity?.legalEntityId !== null && legalEntity?.legalEntityId !== undefined)).pipe(
          map((legalEntity) => new fromLegalEntityAction.SetLegalEntity(legalEntity)),
          catchError((err) => throwError(new fromLegalEntityAction.LoadLegalEntityFailure(err)))
        );
      })
    )
  );

  loadLegalEntityFailure$ = createEffect(
    () =>
      this.actions$?.pipe(
        ofType<fromLegalEntityAction.LoadLegalEntityFailure>(
          fromLegalEntityAction.ActionTypes.LOAD_LEGAL_ENTITY_FAILURE
        ),
        tap((err) => console.error(err))
      ),
    { dispatch: false }
  );

  setLegalEntity$ = createEffect(() =>
    this.actions$?.pipe(
      ofType<fromLegalEntityAction.SetLegalEntity>(fromLegalEntityAction.ActionTypes.SET_LEGAL_ENTITY),
      switchMap((action) => {
        this.featureToggleService.setCustomProperty("customer", action.payload.legalEntityTypeCode);
        return [
          new fromCountryParametersAction.FetchCountryParameters(),
          new fromCompanyAction.FetchCompanies(),
          new FinancialDocumentsAction.Layout.SetView("table"),
        ];
      })
    )
  );
}
